export default {
  setSaasOrgData (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setSaasOrgData", payload)
      resolve()
    })
  }
}
